type PricePerUnitLabelProps = {
    scaleFactor?: number | null;
    units?: string | null;
    locale: string;
};

export function PricePerUnitLabel({ scaleFactor, units, locale }: PricePerUnitLabelProps) {
    const hasScale = scaleFactor != null && scaleFactor > 1;
    const hasUnits = Boolean(units);

    if (!hasScale && !hasUnits) {
        return null;
    }

    const formattedScale = hasScale ? scaleFactor.toLocaleString(locale) : '';
    const formattedUnits = hasUnits ? ` ${units}` : '';

    return (
        <>
            {' / '}
            {formattedScale}
            {formattedUnits}
        </>
    );
}
